import React, { useState, useEffect } from 'react';
import "./styles.css";

function ImageSelector({
  images,
  selectedImages,
  highlightedImages,
  setSelectedImages,
  setHighlightedImages,
  setShowValidationMessage,
  setFilter,
  showValidationMessage,
  resetDefaults,
}) {
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (resetDefaults) {
      setSelectedImages([]);
      setHighlightedImages([]);
      setFilter('all');
    }
  }, [resetDefaults, setSelectedImages, setHighlightedImages, setFilter]);

  const handleImageSelection = (imageSrc) => {
    const updatedSelectedImages = selectedImages.includes(imageSrc)
      ? selectedImages.filter((img) => img !== imageSrc)
      : [...selectedImages, imageSrc];

    setSelectedImages(updatedSelectedImages);
    setHighlightedImages((prev) =>
      prev.includes(imageSrc)
        ? prev.filter((img) => img !== imageSrc)
        : [...prev, imageSrc]
    );

    if (updatedSelectedImages.length > 0) {
      setShowValidationMessage(false);
    }
  };

  return (
    <div>
      <div style={{ marginBottom: '10px' }}>
        <select
          onChange={(e) => setFilter(e.target.value)}
          style={{
            padding: '8px 12px',
            fontSize: '14px',
            borderRadius: '5px',
            border: '1px solid #ccc',
          }}
        >
          <option value="all">All</option>
          <option value="animation">Animation</option>
          <option value="technology">Technology</option>
          <option value="sports">Sports</option>
          <option value="science">Science</option>
        </select>
      </div>

      <div className="image-grid">
        {images.length === 0 ? (
          <p style={{ gridColumn: '1 / -1', textAlign: 'center', color: 'gray' }}>
            No images found for the selected category.
          </p>
        ) : (
          images.map((img, index) => (
            <div
              className="image-overlaycolor"
              key={index}
              style={{
                border: highlightedImages.includes(img.src) ? '3px solid #007bff' : '0px solid white',
                boxShadow: highlightedImages.includes(img.src) ? '0 4px 12px rgba(0, 123, 255, 0.3)' : 'none',
              }}
              onClick={() => handleImageSelection(img.src)}
            >
              <img
                src={img.src}
                alt={`Image ${index + 1}`}
                style={{
                  width: '100%',
                  height: 'auto',
                  objectFit: 'cover',
                  transition: 'transform 0.2s',
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'scale(1.05)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'scale(1)';
                }}
              />
            </div>
          ))
        )}
      </div>

      {showValidationMessage && (
        <div style={{ color: 'red', marginTop: '10px', fontSize: '14px' }}>
          Please select at least one image.
        </div>
      )}

      {message && <div style={{ color: 'red', marginTop: '10px' }}>{message}</div>}
    </div>
  );
}

export default ImageSelector;
